import { ReactNode } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertDialogOverrideStyle } from '@/components/uiWrappers/componentOverrideStyles';
import { cn } from '@/lib/utils';
import {CustomButton} from '@/components/uiWrappers/button.tsx';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  icon?: ReactNode;
  isLoading?: boolean;
  highlightBox?: {
    text: string;
    bgColor?: string;
    textColor?: string;
  };
  variant?: 'danger'|'regular'
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  icon,
  isLoading = false,
  highlightBox,
    variant='danger'
}: ConfirmationModalProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className={AlertDialogOverrideStyle.content}>
        <AlertDialogHeader className={AlertDialogOverrideStyle.header}>
          {/* Icon */}
          {icon && (
            <AlertDialogMedia className={AlertDialogOverrideStyle.media}>
              {icon}
            </AlertDialogMedia>
          )}

          {/* Title */}
          <AlertDialogTitle className={AlertDialogOverrideStyle.title}>
            {title}
          </AlertDialogTitle>

          {/* Description */}
          <AlertDialogDescription className={AlertDialogOverrideStyle.description}>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>

        {/* Highlight Box (optional) */}
        {highlightBox && (
          <div
            className={cn(
              AlertDialogOverrideStyle.highlightBox,
              //  bgColor: 'bg-teal-50',
                //         textColor: 'text-teal-700',
              highlightBox.bgColor || 'bg-primary-soft'
            )}
          >
            <p className={cn('font-semibold text-center text-lg', highlightBox.textColor || 'text-primary')}>
              {highlightBox.text}
            </p>
          </div>
        )}

        {/* Action Buttons */}
        <AlertDialogFooter className={AlertDialogOverrideStyle.footer}>
          <AlertDialogCancel asChild>
            <CustomButton
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 hover:bg-primary-soft hover:text-primary hover:border-primary"
            >
              {cancelText}
            </CustomButton>
          </AlertDialogCancel>
          <AlertDialogAction
              variant={variant=== 'danger' ? 'destructive' : 'default'}
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1"
          >
            {isLoading ? 'Processing...' : confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
